import * as fontLoader from './modules/font-loader';
import { lazy as LazyLoader } from './modules/lazy-loader';
import { init as embedLoader } from './modules/lazy-embed';
import { init as Maps } from './modules/google-maps';
import { init as Menu } from './modules/menu';
import { init as Slideshows } from './modules/slideshows';
import { init as Brands } from './modules/brands';

init();

function init() {
	fontLoader.load();
	Menu();
	LazyLoader().update();
	Slideshows();
	Brands();
	embedLoader();
	Maps();
}
